<label [for]="vm.name">
  @if (vm.label) {
  <span class="label">{{ vm.label }}</span>
  }

  <section class="holder">
    <input
      (ngModelChange)="writeValue($event)"
      [placeholder]="vm.placeHolder"
      [ngModel]="value"
      [id]="vm.name"
      [attr.name]="vm.name"
      [disabled]="disabled"
      (focus)="onFocus.emit()"
      type="text"
      class="body"
      autocomplete="off"
    />
    <ng-content select="[icon-end]" />
  </section>
</label>
